
window.addEventListener('DOMContentLoaded', (event) => {

  // === Modal Global functions

  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  window.addEventListener('scroll', () => {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
  });

  function openModalBedrooms(modal) {
    if (modal !== null && modal !== undefined) {
      modal.classList.toggle('active');
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    }
  }

  function closeModalBedrooms(modal) {
    if (modal !== null && modal !== undefined) {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo({
        left: 0,
        top: parseInt(scrollY || '0') * -1,
        behavior: 'instant'
      });
      modal.classList.toggle('active');
    }
  }

  // === Modal Bedrooms

  const modalMediaBedrooms = document.querySelector('[data-modal-media-bedrooms]');

  if (modalMediaBedrooms !== null && modalMediaBedrooms !== undefined) {

    const mediaBedroomsToggle = document.querySelectorAll('[data-media-bedrooms-toggle]');
    if (mediaBedroomsToggle.length > 0) {
      mediaBedroomsToggle.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (modalMediaBedrooms.classList.contains('active')) {
            modalMediaBedrooms.classList.toggle('active');
          } else {

            // Show selected bedromms
            const modalBedroomsContent = document.querySelectorAll('[data-media-bedroom-index]');
            const bedroomIndex = button.getAttribute('data-media-bedrooms-toggle');
            if (modalBedroomsContent.length > 0 && bedroomIndex !== null && bedroomIndex !== undefined) {
              modalBedroomsContent.forEach(content => {
                const thisContentIndex = content.getAttribute('data-media-bedroom-index');
                if (thisContentIndex !== null && thisContentIndex !== undefined && thisContentIndex === bedroomIndex) {
                  content.classList.add('active');
                } else {
                  content.classList.remove('active');
                }
              });
            }

            modalMediaBedrooms.classList.toggle('active');

          }

        });
      });
    }
    
  }

});
